{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description }}
{{/if}}
<div class="tool-field">
  <input type="text" placeholder="{{ config.placeholder }}" value="{{ context }}" />
</div>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
